module.exports = __webpack_public_path__ + "static/media/homem_r2_c2.36a93a11.jpg";